var render = function render(){var _vm=this,_c=_vm._self._c;return _c('q-page',{staticClass:"management-page",attrs:{"padding":""}},[_c('PageHeader',{attrs:{"category":_vm.$t(`${_vm.category}`),"title":_vm.title}}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }